// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBar-cls1_GZQ","cls2":"SearchBar-cls2_G0D SearchBar-cls1_GZQ"};